import React from 'react';

import './SecondaryPanel.scss';

export const SecondaryPanel = ({ children, background, color }) => {
  const styles = {
    background,
    color,
  };

  return (
    <div className="sb-header-secondary-panel" style={styles}>
      <div className="sb-header-secondary-panel__content">{children}</div>
    </div>
  );
};
